import React from 'react';
import tpl from '../templates/united_country.jsx';
import BaseNewCardView from '../../../Cards/views/BaseNewCardView.js';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'UnitedCountry.Views.Main';
}
